var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.51189 15.5072L6.513 13.9162C6.99383 13.5344 7.26961 12.9616 7.26961 12.3535L7.26961 9.75137C10.289 8.76849 13.5629 8.76142 16.5893 9.75137L16.5893 12.3677C16.5893 12.9758 16.865 13.5485 17.3459 13.9304L19.3328 15.5072C20.1319 16.1365 21.2703 16.0729 21.9916 15.3517L23.2149 14.1284C24.0139 13.3293 24.0139 12 23.1654 11.2504C16.7519 5.58651 7.0999 5.59358 0.693514 11.2504C-0.155014 12 -0.155012 13.3293 0.644018 14.1284L1.86731 15.3517C2.57442 16.0729 3.71286 16.1365 4.51189 15.5072Z",
    fill: "red"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor",
    transform: "translate(28.9 12.7) rotate(135)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallEnd);
export default __webpack_public_path__ + "static/media/call-end.1855acb6383e66216b3c460601378bac.svg";
export { ForwardRef as ReactComponent };